// extracted by mini-css-extract-plugin
export default {"Slider":"Gallery_Slider__834rk"};